import { EventName } from '@lit/react';
import { BlocksCarousel } from 'blocks-nextjs/blocks-web-components/components/carousel/carousel';
import { BlocksSlideChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatCarousel = createComponent({
  react: React,
  tagName: 'cat-carousel',
  elementClass: BlocksCarousel,
  events: {
    onBlSlideChange: 'bl-slide-change' as EventName<BlocksSlideChangeEvent>
  }
});
